<template>
  <div class="relative">
    <v-btn
          fixed
          dark
          fab
          top
          right
          text
          color="transparent"
          @click="changeFace"
          style="z-index: 9999;margin-top: .5rem"
          >
      <img
        class="face-logo animated slideInRight"
        
        :src="require(`@/assets/${showFace}.png`)"
        draggable="false"
        alt="She Platform"
        height="80"
        :class="{'smallFace': $vuetify.breakpoint.mdAndDown, 'bigFace': $vuetify.breakpoint.lgAndUp}" />
    </v-btn>
    <svg id="organic-blob" width="300" height="300" xmlns="http://www.w3.org/2000/svg" filter="url(#goo)">
      <defs>
        <filter id="goo">
          <!-- tympanus.net/codrops/creative-gooey-effects -->
          <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
          <feComposite in="SourceGraphic" in2="goo" operator="atop"/>
        </filter>
      </defs>
      <circle id="Circle1"></circle>
      <circle id="Circle2"></circle>
      <circle id="Circle3"></circle>
      <circle id="Circle4"></circle>
    </svg>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.mdAndUp"
      dark  
      v-model="bar"
      fixed
      class="primary nav--bar pb-0"
      mini-variant
      mini-variant-width="81"
      value="true"
      hide-overlay
      mobile-breakpoint="959"
    >
      <v-list class="pt-2" dense>

        <v-list-item >
          <v-list-item-action>               
            <p class="menu--title pa-0">{{ menuBar }}</p>
            <v-icon @click="runBounce" v-ripple class="menu--btn animated" :class="{ rubberBand: clicked }" large>{{ menuBar }}</v-icon>
          </v-list-item-action>  
        </v-list-item>
      </v-list> 

    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.mdAndUp"
      v-model="$store.state.drawer"
      class="accent nav-push"
      width="244"
      fixed
      text
      temporary
    >
      <v-layout fill-height>
        <v-list class="grow darken pt-4" v-if="$route.name == 'home'">
          <MainMenu />
          <v-divider light></v-divider>
          <SocialMenu></SocialMenu>
        </v-list>
        <v-list class="grow darken pt-4" v-else>
          <v-list-item
            active-class="menu--active"
            v-ripple
            href="/"
          >
            <v-list-item-title class="menu--item">Home</v-list-item-title>
          </v-list-item>
          <v-divider light></v-divider>
          <div class="pl80">
            
            <SocialMenu></SocialMenu>
          </div>    
        </v-list>        
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>

<script>
import SocialMenu from "./SocialMenu.vue";
import MainMenu from "./MainMenu.vue";
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Sidebar',
  data () {
    return {
      drawer: false,
      bar: true,
      mini: true,
      right: null,
      clicked: false,
      logo: 'she_face',
      lokey: 1,
      bounce: false
    }
  },
  methods: {
    ...mapMutations([
      'changeFace',
      'resetFace'
    ]),
    runBounce() {
      this.$store.state.drawer = !this.$store.state.drawer;
      this.resetFace();
      this.clicked = false;
      setTimeout(() => this.clicked = true, 20);
    },
    onScroll () {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    }
  },
  created () {
    if (this.$route.name == 'thanks') {
      this.$store.state.logoStep = 1 // Set to happy face, maybe change to a celebration later
    } else if (this.$route.name != 'thanks' && this.$route.name != 'home') {
      this.$store.state.logoStep = 2 // Set to thinking face
    }
  },
  computed: {
    ...mapGetters([
      'showFace'
    ]),
    menuBar() {
      if (!this.$store.state.drawer) {
        return 'menu'
      }
      else return 'close'
    }
  },
  components: {
    SocialMenu,
    MainMenu
  }
}
</script>

<style lang="scss" scoped>
.relative {
  position: relative
}
.icon-row {
      text-align: center;
    margin: 0 auto;
    width: 50%;
}
  .nav--bar {
      z-index: 999
  }

  .menu {
    &--btn {
      background: #6075bd;
      padding: 19px;
      width: 40px;
      border-radius: 6px;
      overflow: hidden;
      &:hover {
        background: #677eca;
      }
    }
    &--title {
      margin: 0;
      padding-top: 28px;
      transform: translateX(-4px);
      font-family: 'Baloo', sans-serif;
    }
    &--item {
      color: white;
      font-size: 2rem;
      font-family: 'Baloo', cursive !important;
    }
  }
  .face-logo {
    z-index: 999;
    position: relative
  }
  .v-list__tile__title {
      text-align: center;
  }
  .theme--dark.v-list .v-list__tile--link:hover {
      background-color: transparent !important;
  }
  .v-overlay {
    z-index: 1;
  }
  .v-divider.theme--light {
    width: 80%;
    margin: 10px auto;
    border-color: rgba(255, 255, 255, 0.36) !important;
  }
 .v-btn--floating.v-btn--fixed {
    z-index: 1000;
    height: 80px;
  }
  svg#organic-blob {
    position: fixed;
    top: -150px;
    right: -140px;
    z-index: 9998;
}
svg,
svg circle {
  fill: #6d8bf0;
}
.menu--btn {
  height: 40px;
}
@keyframes from0to360 {
  from{transform:rotate(0);}
  to{transform:rotate(360deg);}
}

#Circle1 {
  animation: from0to360 9s linear infinite;
  cx: 150;
  cy: 145;
  r: 100;
  transform-origin: 145px 150px;
}

@keyframes from360to0 {
  from{transform:rotate(360deg);}
  to{transform:rotate(0deg);}
}

#Circle2 {
  animation: from360to0 9s linear infinite;
  cx: 150;
  cy: 155;
  r: 100;
  transform-origin: 155px 150px;
}

#Circle3 {
  animation: from0to360 9s linear infinite;
  cx: 145;
  cy: 150;
  r: 100;
  transform-origin: 150px 145px;
}

#Circle4 {
  animation: from360to0 8s linear infinite;
  cx: 155;
  cy: 150;
  r: 100;
  transform-origin: 150px 155px;
}
.nav-push {
  left: 80px;
}
.smallFace {
  position: relative; top: -15px; left: -1px; height: 70px;
}
.bigFace {
  position: relative; top: -10px; left: -1px;
}
</style>
